/**
 * System Option Sets
 *
 * These are distinguished from other option sets as follows:
 *
 * 1. They cannot be deleted
 * 2. Their IDs are static instead of coming from uid()
 */

export enum SystemOptionSet {
  ELEVATION_STYLE = "elevationStyle",
  MIRROR = "mirror",
  INTERIOR_PALETTE = "interiorPalette",
}
